import { ClientAwareEvaluatorAttribute, ClientAwareEvaluatorAttributePropertyValues, IClientAwareEvaluatorAttribute } from "./ClientAwareEvaluatorAttribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareRelevantEvaluatorAttributePropertyValues =
    ClientAwareEvaluatorAttributePropertyValues
    & {
    };

export type ClientAwareRelevantEvaluatorAttributeProperties = {
    [name in keyof ClientAwareRelevantEvaluatorAttributePropertyValues]?: ClientAwareRelevantEvaluatorAttributePropertyValues[name];
};

export interface IClientAwareRelevantEvaluatorAttribute extends IClientAwareEvaluatorAttribute, ClientAwareRelevantEvaluatorAttributeProperties
{
}

export class ClientAwareRelevantEvaluatorAttribute extends ClientAwareEvaluatorAttribute implements IClientAwareRelevantEvaluatorAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareRelevantEvaluatorAttribute";
    public static override className = "ClientAwareRelevantEvaluatorAttribute";

    constructor(propertyValues?: Partial<ClientAwareRelevantEvaluatorAttributePropertyValues>)
    {
        super(propertyValues);
    }
}